import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'token';
    this.token = new Login();
  }

  all(page = 1, buscar = ''){
    return this.http.get<Object[]>(this.url + '?q=' + buscar, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  criar(dados : any) {
    return this.http.post<Object[]>(this.url, dados, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
  atualizar(id: any, dados : any) {
    return this.http.put<Object[]>(this.url + '/' + id, dados, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
  
  
  excluir(id: any){
    return this.http.delete<Object[]>(this.url+ '/' + id, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  detalhar(id: any){
    return this.http.get<Object[]>(this.url + '/' + id, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  enviarEmail(id: any){
    return this.http.post<Object[]>(this.url + '/enviar-email/' + id, {},{
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  habilidades(){
    return this.http.get<Object[]>(this.url + '/habilidades', {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
